/**
 * Rebuilt "YEAR Make Model Specs" hub layout.
 *
 * Shipped to a two-model sample first, reviewed, and now rolled out site-wide.
 * Kept as a function so the layout can be re-gated quickly if needed.
 */
export function isSpecsHubSample(_makeSlug: string, _modelSlug: string): boolean {
  return true;
}
